export default [
  {
    name: 'EJEMPLO1_FTP',
    connectorId: 'EJEMPLO1_FTP',
    layerName: 'via_ferrea__T2hjjeTigxNQ965ai__20210108T0637',
    attributes: ['area', 'id']
  },
  {
    name: 'EJEMPLO1_POSTGRESSQL',
    connectorId: 'EJEMPLO1_POSTGRESSQL',
    layerName: 'distritos',
    attributes: [
      'cod_postal',
      'cod_distrito',
      'natcode_municipio',
      'municipio',
      'natcode_provincia',
      'provincia',
      'natcode_ccaa',
      'ccaa',
      'gid_0',
      'name_0',
      'geom',
      'url_propia',
      'url_arriba',
      'url_abajo',
      'nivel_propio',
      'nivel_padre',
      'nivel_hijo',
      'name',
      'id_srm'
    ]
  },
  {
    name: 'EJEMPLO1_POSTGRESSQL',
    connectorId: 'EJEMPLO2_POSTGRESSQL',
    layerName: 'municipios_madrid',
    attributes: [
      'id_srm',
      'cod_postal',
      'natcode_municipio',
      'municipio',
      'natcode_provincia',
      'provincia',
      'natcode_ccaa',
      'ccaa',
      'gid_0',
      'name_0',
      'geom',
      'url_propia',
      'url_arriba',
      'url_abajo',
      'nivel_propio',
      'nivel_padre',
      'nivel_hijo',
      'name'
    ]
  },
  {
    name: 'EJEMPLO1_HTTP',
    connectorId: 'EJEMPLO1_HTTP',
    layerName: 'csv_aleatorio',
    attributes: ['id', 'cosas', 'cosas2']
  }
];
